import {Payment, PaymentCreate} from './payment.model';
import {Passenger} from './passenger.model';
import {Upload, UploadCreate} from './upload.model';
import {Ticket} from './ticket.model';

export class Reservation {

    public id: number;
    public user_id: number;
    public discount_id: number;
    public email: string;
    public phone: string;
    public comment: string;
    public is_valid_ticket: number;
    public reservation_no: string;
    public qr: string;
    public status: string;
    public payment: Payment[];
    public upload: Upload[];
    public passenger: Passenger[];
    public ticket: Ticket;
    public ticket_re: Ticket;
    public modified: string;
    public created: string;

    constructor(id: number, user_id: number, email: string, phone: string, comment: string, is_valid_ticket: number, status: string,
                modified: string, created: string, ticket: Ticket,
                passenger: Passenger[], payment?: Payment[], upload?: Upload[], ticket_re?: Ticket) {
        this.id = id;
        this.user_id = user_id;
        this.email = email;
        this.phone = phone;
        this.comment = comment;
        this.is_valid_ticket = is_valid_ticket;
        this.status = status;
        this.user_id = user_id;
        this.modified = modified;
        this.created = created;
        this.passenger = passenger;
        this.payment = payment;
        this.upload = upload;
        this.ticket = ticket;
        this.ticket_re = ticket_re;
    }
}

export class ReservationUpdate {

    public id: number;
    public email: string;
    public phone: string;
    public comment: string;
    public is_valid_ticket: number;
    public status: string;
    public user_id: string;
    public discount_id: string;

    constructor(id: number, email: string, phone: string, comment: string, is_valid_ticket: number,
                status: string, user_id: string, discount_id: string) {
        this.id = id;
        this.email = email;
        this.phone = phone;
        this.comment = comment;
        this.is_valid_ticket = is_valid_ticket;
        this.status = status;
        this.user_id = user_id;
        this.discount_id = discount_id;
    }
}

export class ReservationCreate {

    public user_id: number;
    public discount_id: number;
    public email: string;
    public phone: string;
    public comment: string;
    public is_valid_ticket: number;
    public status: string;
    public payment: PaymentCreate;
    public upload: UploadCreate[];

    constructor(user_id: number, discount_id: number, email: string,
                phone: string, comment: string, is_valid_ticket: number, status: string,
                payment?: PaymentCreate, upload?: UploadCreate[]) {
        this.user_id = user_id;
        this.discount_id = discount_id;
        this.email = email;
        this.phone = phone;
        this.comment = comment;
        this.is_valid_ticket = is_valid_ticket;
        this.status = status;
        this.payment = payment;
        this.upload = upload;
    }

}
